/**
 * County-specific required field configuration for AcceptQuoteModal
 * Ported from legacy quoteDetailModal.jsx
 */

const COUNTY_REQUIRED_FIELDS = {
  // Bell County
  55941: [
    'defendantStreet', 'defendantCity', 'defendantState', 'defendantZipCode',
    'defendantPhoneNumber', 'socialSecurityNumber', 'placeOfBirth',
    'hairColor', 'eyeColor', 'race', 'weight', 'jailInfo',
  ],
  // Cameron County
  55853: [
    'nearestRelativeName', 'nearestRelativeAddressStreet1',
    'nearestRelativeAddressCity', 'nearestRelativeAddressState',
    'nearestRelativeAddressZipCode',
  ],
  // Comal County
  56002: [
    'height', 'weight', 'defendantStreet', 'defendantCity',
    'defendantState', 'defendantZipCode', 'defendantPhoneNumber',
    'driversLicenseNumber', 'nextOfKinName', 'nextOfKinPhoneNumber',
    'nextOfKinAddressStreet1', 'nextOfKinAddressCity',
    'nextOfKinAddressState', 'nextOfKinAddressZipCode',
  ],
  // Coryell County
  55874: ['driversLicenseNumber', 'socialSecurityNumber', 'placeOfBirth'],
  // Dallas County
  55857: [
    'defendantStreet', 'defendantCity', 'defendantState', 'defendantZipCode',
    'firstName', 'lastName', 'dateOfBirth', 'gender', 'race', 'bookingNumber',
  ],
  // Ellis County
  55926: [
    'nextOfKinName', 'nextOfKinPhoneNumber', 'nextOfKinAddressStreet1',
    'nextOfKinAddressCity', 'nextOfKinAddressState', 'nextOfKinAddressZipCode',
    'height', 'weight', 'hairColor', 'eyeColor', 'race', 'gender',
    'driversLicenseNumber', 'driversLicenseState', 'placeOfBirth',
  ],
  // Galveston County
  55881: [
    'defendantStreet', 'defendantCity', 'defendantState',
    'defendantZipCode', 'height', 'weight',
  ],
  // Harris County (no additional fields beyond defaults)
  55856: [],
  // Hidalgo County
  55852: [
    'defendantStreet', 'defendantCity', 'defendantState', 'defendantZipCode',
    'defendantPhoneNumber', 'eyeColor', 'hairColor', 'weight', 'placeOfBirth',
  ],
  // Midland County
  55991: ['arrestDate'],
  // Parker County
  55872: [
    'defendantStreet', 'defendantCity', 'defendantState',
    'defendantZipCode', 'dateOfBirth',
  ],
  // Wise County
  55885: [
    'defendantStreet', 'defendantCity', 'defendantState',
    'defendantZipCode', 'dateOfBirth',
  ],
  // Tarrant County
  55912: ['dateOfBirth'],
  // Alameda County
  53706: ['pfnNumber'],
};

const DEFAULT_REQUIRED = ['firstName', 'lastName', 'totalBondAmount'];

export const getRequiredFields = (countyId) => {
  return [...DEFAULT_REQUIRED, ...(COUNTY_REQUIRED_FIELDS[countyId] || [])];
};

export const FIELD_LABELS = {
  firstName: 'First Name',
  middleInitial: 'Middle Initial',
  lastName: 'Last Name',
  totalBondAmount: 'Total Bond Amount',
  dateOfBirth: 'Date of Birth',
  bookingNumber: 'Booking Number',
  driversLicenseNumber: "Driver's License Number",
  driversLicenseState: "Driver's License State",
  race: 'Race',
  gender: 'Gender',
  placeOfBirth: 'Place of Birth',
  socialSecurityNumber: 'Social Security Number',
  arrestDate: 'Arrest Date',
  jailPhoneNumber: 'Jail Phone Number',
  jailInfo: 'Jail Info',
  courtCode: 'Court Code',
  courtPlace: 'Courthouse',
  defendantStreet: 'Defendant Street',
  defendantCity: 'Defendant City',
  defendantState: 'Defendant State',
  defendantZipCode: 'Defendant Zip Code',
  defendantPhoneNumber: 'Defendant Phone',
  hairColor: 'Hair Color',
  eyeColor: 'Eye Color',
  weight: 'Weight',
  height: 'Height',
  xrefNumber: 'XREF Number',
  pfnNumber: 'PFN Number',
  nextOfKinName: 'Next of Kin Name',
  nextOfKinPhoneNumber: 'Next of Kin Phone',
  nextOfKinAddressStreet1: 'Next of Kin Street',
  nextOfKinAddressStreet2: 'Next of Kin Street 2',
  nextOfKinAddressCity: 'Next of Kin City',
  nextOfKinAddressState: 'Next of Kin State',
  nextOfKinAddressZipCode: 'Next of Kin Zip Code',
  nearestRelativeName: 'Nearest Relative Name',
  nearestRelativeAddressStreet1: 'Nearest Relative Street',
  nearestRelativeAddressStreet2: 'Nearest Relative Street 2',
  nearestRelativeAddressCity: 'Nearest Relative City',
  nearestRelativeAddressState: 'Nearest Relative State',
  nearestRelativeAddressZipCode: 'Nearest Relative Zip Code',
};

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];
